import { Form, Modal } from "react-bootstrap";
import "./Success_Modal.css";
import Successfull_Lottie from "../../../animation/successfull_lottie/Successfull_Lottie";
// import Green_Check_Lottie from '../../../animation/green_check_lottie/Green_Check_Lottie';
import Pink_Btn from "../../common_btn/pink_btn/Pink_Btn";

const Success_Modal = (props) => {
  // setTimeout(() => {
  //     props?.onHide()
  // }, 10000);

  return (
    <Modal className="Success_Modal" size="sm" {...props} centered>
      <div className="absolute_div">
        <div className="animation_holder">
          <Successfull_Lottie />
        </div>
      </div>

      <Modal.Body>
        <p className="success_text">{props?.successText}</p>

        {props?.btnname ? <Pink_Btn btnText={props?.btnname} /> : null}
      </Modal.Body>
    </Modal>
  );
};

export default Success_Modal;
